import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { verifyPaymentCallback } from "../actions/ordersActions";
import "./PaymentCallback.css";

const PaymentCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { loading, paymentCallbackStatus, error } = useSelector(
    (state) => state.orders
  );

  useEffect(() => {
    const handlePaymentCallback = async () => {
      try {
        // Get query parameters from URL
        const urlParams = new URLSearchParams(location.search);
        const orderTrackingId = urlParams.get("OrderTrackingId");
        const merchantReference = urlParams.get("OrderMerchantReference");

        if (!orderTrackingId || !merchantReference) {
          return;
        }

        // Dispatch the payment callback verification action
        await dispatch(
          verifyPaymentCallback(orderTrackingId, merchantReference)
        );
      } catch (err) {
        console.error("Payment callback error:", err);
      }
    };

    handlePaymentCallback();
  }, [location.search, dispatch]);

  const handleContinueShopping = () => {
    navigate("/");
  };

  const handleViewOrder = () => {
    if (paymentCallbackStatus?.order_id) {
      navigate(`/orders/${paymentCallbackStatus.order_id}`);
    }
  };

  const handleRetryPayment = () => {
    navigate("/cart");
  };

  if (loading) {
    return (
      <div className="payment-callback-container">
        <div className="payment-callback-content">
          <div className="loading-spinner">
            <div className="spinner"></div>
          </div>
        </div>
      </div>
    );
  }

  // Check for missing parameters error
  const urlParams = new URLSearchParams(location.search);
  const orderTrackingId = urlParams.get("OrderTrackingId");
  const merchantReference = urlParams.get("OrderMerchantReference");

  if (!orderTrackingId || !merchantReference) {
    return (
      <div className="payment-callback-container">
        <div className="payment-callback-content">
          <div className="payment-status error">
            <div className="status-icon error-icon">
              <i className="fas fa-exclamation-triangle"></i>
            </div>
            <h2>Payment Verification Failed</h2>
            <p className="error-message">Missing required payment parameters</p>
            <div className="action-buttons">
              <button onClick={handleRetryPayment} className="btn btn-primary">
                Try Again
              </button>
              <button
                onClick={handleContinueShopping}
                className="btn btn-secondary"
              >
                Continue Shopping
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="payment-callback-container">
        <div className="payment-callback-content">
          <div className="payment-status error">
            <div className="status-icon error-icon">
              <i className="fas fa-exclamation-triangle"></i>
            </div>
            <h2>Payment Verification Failed</h2>
            <p className="error-message">{error}</p>
            <div className="action-buttons">
              <button onClick={handleRetryPayment} className="btn btn-primary">
                Try Again
              </button>
              <button
                onClick={handleContinueShopping}
                className="btn btn-secondary"
              >
                Continue Shopping
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const isPaymentSuccessful = paymentCallbackStatus?.payment_completed;

  return (
    <div className="payment-callback-container">
      <div className="payment-callback-content">
        <div
          className={`payment-status ${
            isPaymentSuccessful ? "success" : "failed"
          }`}
        >
          <div
            className={`status-icon ${
              isPaymentSuccessful ? "success-icon" : "failed-icon"
            }`}
          >
            {isPaymentSuccessful ? (
              <i className="fas fa-check-circle"></i>
            ) : (
              <i className="fas fa-times-circle"></i>
            )}
          </div>

          <h2>
            {isPaymentSuccessful ? "Payment Successful!" : "Payment Failed"}
          </h2>

          <p className="status-message">
            {isPaymentSuccessful
              ? "Your payment has been processed successfully. You will receive a confirmation email shortly."
              : "Unfortunately, your payment could not be processed. Please try again or contact support if the problem persists."}
          </p>

          {paymentCallbackStatus?.order_id && (
            <div className="order-info">
              <p>
                <strong>Order ID:</strong> {paymentCallbackStatus.order_id}
              </p>
              <p>
                <strong>Status:</strong> {paymentCallbackStatus.payment_status}
              </p>
            </div>
          )}

          <div className="action-buttons">
            {isPaymentSuccessful ? (
              <>
                <button onClick={handleViewOrder} className="btn btn-primary">
                  View Order Details
                </button>
                <button
                  onClick={handleContinueShopping}
                  className="btn btn-secondary"
                >
                  Continue Shopping
                </button>
              </>
            ) : (
              <>
                <button
                  onClick={handleRetryPayment}
                  className="btn btn-primary"
                >
                  Try Payment Again
                </button>
                <button
                  onClick={handleContinueShopping}
                  className="btn btn-secondary"
                >
                  Continue Shopping
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCallback;
